// extracted by mini-css-extract-plugin
module.exports = {"card":"CardTitle_card__f4oCd","cardVertical":"CardTitle_cardVertical__3oz3W","content":"CardTitle_content__ZJdls"};